import React from 'react';

import IndexPaginationNav from 'buyside/components/presentation/IndexPaginationNav/indexPaginationNav';
import MembersIndexCard from 'buyside/components/presentation/MembersIndexPage/MembersIndexCard/membersIndexCard';

const UserFollowersList = ({ followersList, activeFollowersCount, canViewUserDetails }) => {
  if (!followersList) return <div>There are no members following you.</div>;
  return (
    <div>
      {followersList.map(({ node }) => (
        <div data-test="follower-card" key={node.user.id}>
          <MembersIndexCard node={node} canViewUserDetails={canViewUserDetails} />
        </div>
      ))}
      <IndexPaginationNav
        resultCount={activeFollowersCount}
        resultLength={followersList.length}
        resultsPerPage={20}
      />
    </div>
  );
};

export default UserFollowersList;
